
/* injects from baggage-loader */

export const cardsQuestion = [
"Qual o nome da entrevistada?",
"O que levou a entrevistada a querer fazer vídeos?",
"De onde vêm as ideias para a criação dos vídeos?",
"Quais são os aparelhos utilizados para gravar os vídeos?",
"Em quais plataformas os vídeos são postados?",
"Qual o conselho é dado para crianças que querem fazer vídeos?"];

export const cards = [
{
  icon: "icon1",
  text: "Maria Clara",
  answered: false
},
{
  icon: "icon2",
  text: "Ver pessoas fazendo vídeos e ter o seu próprio canal.",
  answered: false
},
{
  icon: "icon3",
  text: "Vídeos antigos e acontecimentos do dia a dia.",
  answered: false
},
{
  icon: "icon4",
  text: "Celular ou tablet.",
  answered: false
},
{
  icon: "icon5",
  text: "YouTube e Music.ly.",
  answered: false
},
{
  icon: "icon6",
  text: "Siga seu sonho e grave.",
  answered: false
}]


// WEBPACK FOOTER //
// ./src/app/pages/page-seven/page-seven.const.js